import { formatDatePtBr, isValidDate, normalizeDayStart, parseBackendDate } from '../../utils/dateUtils';
import { getPhoneDigits } from '../../utils/maskCpfCnpj';
import { parseNumberPtBr } from '../../utils/numberUtils';
import { formatCurrency, isBlank } from '../../utils/stringFormat';

export const STATUS_OPTIONS = [
    { id: 1, label: 'Em negociação' },
    { id: 2, label: 'Não Responde' },
    { id: 3, label: 'Vetado - Valor mínimo' },
    { id: 4, label: 'Vetado - Baixa Renda' },
    { id: 5, label: 'Vetado - Crefaz' },
    { id: 6, label: 'Vetado - Serasa' },
    { id: 7, label: 'Vetado - Estado' },
    { id: 8, label: 'Concluído' },
    { id: 9, label: 'Vetado - Importe' },
    { id: 10, label: 'Transferido' },
    { id: 11, label: 'Titularidade' },
    { id: 12, label: 'Cancelado' },
    { id: 13, label: 'Sem Interesse' }
];

export const FASE_OPTIONS = [
    { id: 1, label: 'Prospecção' },
    { id: 2, label: 'Proposta Enviada' },
    { id: 3, label: 'Negociação Comercial' },
    { id: 4, label: 'Contrato Emitido' },
    { id: 5, label: 'Conquistado' }
];

export const ORIGEM_OPTIONS = [
    { id: 1, label: 'Telemarketing' },
    { id: 2, label: 'Meta' },
    { id: 3, label: 'Indicação' },
    { id: 4, label: 'Google' },
    { id: 5, label: 'Ativação Condomínio' },
    { id: 6, label: 'Parceiro Comercial' },
    { id: 7, label: 'WhatsApp' },
    { id: 8, label: 'APP' },
    { id: 9, label: 'Ativação Empresas' },
    { id: 10, label: 'Folder' },
    { id: 11, label: 'Influencer' },
    { id: 12, label: 'Eventos' },
    { id: 13, label: 'Publicidade' },
    { id: 14, label: 'CTW' },
    { id: 15, label: 'WA Google' },
    { id: 16, label: 'WA Meta' },
    { id: 17, label: 'Direct Meta' },
    { id: 18, label: 'TikTok' },
    { id: 19, label: 'Email' },
    { id: 20, label: 'Blog' },
    { id: 21, label: 'Linkedin' },
    { id: 22, label: 'Mobile' },
    { id: 23, label: 'Globo' },
    { id: 24, label: 'ChatGPT' }
];

export const ORIGEM_GROUPS = [
    { value: 'canal_meta', label: 'Canal Meta', childIds: [2, 14, 16, 17] },
    { value: 'canal_google', label: 'Canal Google', childIds: [4, 15] }
];

export const STATUS_GROUPS = [
    {
        value: 'vetados',
        label: 'Vetados',
        childIds: STATUS_OPTIONS
            .filter((option) => option.label.startsWith('Vetado - '))
            .map((option) => option.id)
    }
];

const buildGroupedFilterOptions = (options, groups, compareOptions) => {
    const sortOptions = (items) => (compareOptions ? [...items].sort(compareOptions) : items);
    const toOption = (option) => ({ value: option.id, label: option.label });
    const groupedIds = new Set(groups.flatMap((group) => group.childIds));

    const groupOptions = groups.flatMap((group) => {
        const children = options.filter((option) => group.childIds.includes(option.id));
        if (children.length === 0) return [];

        return [
            { value: group.value, label: group.label, childValues: children.map((option) => option.id) },
            ...sortOptions(children.map(toOption)).map((option) => ({ ...option, nested: true }))
        ];
    });

    const looseOptions = sortOptions(
        options
            .filter((option) => !groupedIds.has(option.id))
            .map(toOption)
    );

    return [...groupOptions, ...looseOptions];
};

export const buildGroupedOriginOptions = (compareOptions, originOptions = ORIGEM_OPTIONS) => (
    buildGroupedFilterOptions(originOptions, ORIGEM_GROUPS, compareOptions)
);

export const buildGroupedStatusOptions = (compareOptions) => (
    buildGroupedFilterOptions(STATUS_OPTIONS, STATUS_GROUPS, compareOptions)
);

export const VENDEDOR_OPTIONS = [
    { id: 1, label: 'Agente IA' },
    { id: 2, label: 'Mauro Filho', email: 'maurofarias@settaenergia.com.br' },
    { id: 4, label: 'João Pedro', email: 'joaopedro@settaenergia.com.br' },
    { id: 12, label: 'Monik Oliveira', email: 'monikoliveira@settaenergia.com.br' },
    { id: 13, label: 'Natalia Farias', email: 'nataliafarias@settaenergia.com.br' },
    { id: 14, label: 'Itaiara Falcão', email: 'itaiarafalcao@settaenergia.com.br' },
    { id: 15, label: 'Jéssica Pereira', email: 'jessicapereira@settaenergia.com.br' },
    { id: 16, label: 'Camila Viana', email: 'camilaviana@settaenergia.com.br' },
    { id: 17, label: 'Tarciana Cunha', email: 'tarcianacunha@settaenergia.com.br' }
];

export const LEAD_COLUMNS = [
    { field: 'lead_id', headerName: 'ID', width: 88 },
    { field: 'cliente_id', headerName: 'Matrícula', width: 112 },
    { field: 'nome', headerName: 'Nome', width: 220 },
    { field: 'fase', headerName: 'Fase', width: 156 },
    { field: 'ticket', headerName: 'Ticket', width: 116 },
    { field: 'vendedor', headerName: 'Vendedor', width: 150 },
    { field: 'telefone', headerName: 'Telefone', width: 140 },
    { field: 'status', headerName: 'Status', width: 150 },
    { field: 'email', headerName: 'Email', width: 220 },
    { field: 'cpf', headerName: 'CPF/CNPJ', width: 160 },
    { field: 'origem', headerName: 'Origem', width: 160 },
    { field: 'cadastro', headerName: 'Data Cadastro', type: 'datetime', width: 150 },
    { field: 'phase_four_date', headerName: 'Data Contrato', type: 'datetime', width: 150 },
    { field: 'phase_five_date', headerName: 'Data Conquistado', type: 'datetime', width: 156 },
    { field: 'cupom', headerName: 'Cupom', width: 140 },
    { field: 'source', headerName: 'Source', width: 150 },
    { field: 'campaign', headerName: 'Campanha', width: 150 },
    { field: 'content', headerName: 'Conjunto', width: 150 },
    { field: 'term', headerName: 'Anúncio', width: 150 }
];

const statusToneByLabel = {
    'Em negociação': 'is-status-active',
    'Não Responde': 'is-status-waiting',
    Concluído: 'is-status-success',
    Transferido: 'is-status-transfer',
    Titularidade: 'is-status-ownership'
};

const phaseToneByLabel = {
    Prospecção: 'is-phase-prospect',
    'Proposta Enviada': 'is-phase-proposal',
    'Negociação Comercial': 'is-phase-negotiation',
    'Contrato Emitido': 'is-phase-contract',
    Conquistado: 'is-phase-won'
};

export const getLeadStatusToneClass = (status) => {
    if (!status) return 'is-status-neutral';
    if (String(status).startsWith('Vetado')) return 'is-status-blocked';
    return statusToneByLabel[status] ?? 'is-status-neutral';
};

export const getLeadPhaseToneClass = (phase) => phaseToneByLabel[phase] ?? 'is-phase-neutral';

export const formatLeadColumnValue = (column, value) => {
    if (isBlank(value)) return '';
    if (column.field === 'ticket') return formatCurrency(parseNumberPtBr(value));
    if (column.type !== 'datetime') return String(value);

    return formatDatePtBr(value);
};

export const getSellerIdByEmail = (email) => {
    const seller = VENDEDOR_OPTIONS.find((option) => option.email === email);
    return seller ? seller.id : null;
};

export const getOptionIdByLabel = (options, label) => {
    const item = options.find((option) => option.label === label);
    return item ? item.id : null;
};

const BR_COUNTRY_CODE = '55';
const DAY_IN_MS = 86400000;

export const buildWhatsAppUrl = (phone, text = '') => {
    const query = text ? `?text=${encodeURIComponent(text)}` : '';
    return `https://wa.me/${BR_COUNTRY_CODE}${getPhoneDigits(phone)}${query}`;
};

export const getDaysSince = (value) => {
    const date = parseBackendDate(value);
    if (!isValidDate(date)) return null;
    return Math.max(0, Math.round((normalizeDayStart(new Date()) - normalizeDayStart(date)) / DAY_IN_MS));
};

export const formatDaysAgo = (days) => {
    if (days === null) return '';
    if (days === 0) return 'hoje';
    return days === 1 ? 'há 1 dia' : `há ${days} dias`;
};

const getFirstName = (name) => {
    const firstName = (name ?? '').toString().trim().split(/\s+/)[0] ?? '';
    return firstName ? firstName.charAt(0).toLocaleUpperCase('pt-BR') + firstName.slice(1).toLocaleLowerCase('pt-BR') : '';
};

export const buildSignatureReminderText = (name) => {
    const firstName = getFirstName(name);
    const greeting = firstName ? `Olá, ${firstName}!` : 'Olá!';
    return `${greeting} Tudo bem? O seu contrato com a Setta Energia já está disponível para assinatura. Ficou alguma dúvida que eu possa ajudar?`;
};
